import React from 'react';
import PropTypes, { element } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import accountingIcon from "assets/img/accountingIcon.png";
import CustomerDefaultIcon from "assets/img/premiumUserIcon.png";
import increaseIcon from "assets/img/increaseIcon.png";
import RentalIcon from "assets/img/plugoboxImg.png";
import BoxInventoryReport from "./BoxInventoryReport.jsx";
import BoxStatusReport from "./BoxStatusReport/BoxStatusReport.jsx";
import StoreStatusReport from './StoreStatusReport/StoreStatusReport.jsx';
import RevenueReport from "./RevenueReport.jsx";
import InvoiceReport from './InvoiceReport/InvoiceReport.jsx'
import SalesLeadReport from "./SalesLeadReport.jsx";
// import SecurityDepositReport from "./SecurityDepositReport/SecurityDepositReport.jsx";
//import IncomeReportByStore from "./IncomeReport/IncomeReportByStore.jsx";
import IncomeReportByStore from './IncomeReport/IncomeReportByStore.jsx';
import PowerBankTransactionReport from "./PowerBankTransactionReport/TransactionReportByCity.jsx";
import CustomerDefaultReport from "./CustomerDefaultReport/CustomerDefaultReport.jsx";
// import { User } from '../../User';
import Secure from '../../components/Secure.jsx';
import MerchantRevenueReport from './MerchantRevenueReport/MerchantRevenueReport';
import RentalHistory from './RentalHistory/RentalHistory.jsx';
import RentalHistoryReport from './RentalHistory/RentalHistoryReport.jsx';
import { connect } from "react-redux";
import FailureReport from './FailureReport/FailureReport.jsx';

const TabContainer = (props) => {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}
TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};
const styles = theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  imgStyle: {
    width: 30,
    height: 35
  }
});

class ReportTabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      europeflag: false,
      activetab: '',
      activetabbody: [],
      india: [
        {
          value: 0,
          secure: 'MAP_BOX_USER',
          component: 'PowerBankTransactionReport'
        },
        {
          value: 1,
          secure: 'MAP_BOX_USER',
          component: 'IncomeReport'
        },
        {
          value: 2,
          secure: 'MAP_BOX_USER',
          component: 'BoxStatusReport'
        },
        {
          value: 3,
          secure: 'VIEW_INVENTORY',
          component: 'BoxInventoryReport'
        },
        {
          value: 4,
          secure: 'VIEW_DEFAULT_CUSTOMER',
          component: 'CustomerDefaultReport'
        },
        // {
        //   value: 5,
        //   secure: 'VIEW_REVENUE',
        //   component: 'RevenueReport'
        // },
        {
          value: 5,
          secure: 'VIEW_REVENUE',
          component: 'InvoiceReport'
        },
        {// secure for store status change
          value: 7,
          secure: 'MAP_BOX_USER',
          component: 'StoreStatusReport'
        },
        // ,
        // {
        //   value:6,
        //   secure:'VIEW_BOX_STATUS',
        //   component:'PowerBankTransactionReport'
        // }
        {
          value: 8,
          secure: 'MAP_BOX_USER',
          component: 'RentalHistoryReport'
        },
        {
          value: 9,
          secure: 'MAP_BOX_USER',
          component: 'RentalHistory'
        },
        {
          value: 10,
          secure: 'CREATE_USERS',
          component: 'FailureReport'
        },
      ],
      permissions_tab: [
        {
          Security: 'Refresh',
          Label: 'Refresh',
          SRC: RentalIcon
        },
      ]
    }
  }
  handleChange = (event, newValue) => {
    console.log({event, newValue})
    this.setState({
      value: newValue
    })
  }

  componentWillMount() {
    if (process.env.REACT_APP_ACTIVE_REGION == "europe") {
      this.setState({
        europeflag: true,
        permissions_tab: this.props.tab_permission.permissions_europe
      })
    }
    else {
      this.setState({
        europeflag: false,
        permissions_tab: this.props.tab_permission.permissions_india
      })
    }
  }

  componentDidMount() {
    const { classes } = this.props;

    let tabbody = this.state.india.map(elem => {
      { this.state.value === 0 && Secure("VIEW_RENTALS", <TabContainer><PowerBankTransactionReport /></TabContainer>) }
      return this.state.value === elem.value && Secure(elem.secure, <TabContainer><elem.component /></TabContainer>)
    })

    let tabs = this.state.permissions_tab.map((elem) => {

      return Secure(elem.Security, <Tab  label={elem.Label} icon={<img className={classes.imgStyle} alt={elem.Label} src={elem.SRC}></img>} />)
    })

    this.setState({
      activetab: tabs,
      activetabbody: tabbody
    })


  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <AppBar position="static" color="default">
          <Tabs
            value={this.state.value}
            onChange={this.handleChange}
            variant="scrollable"
            scrollButtons="on"
            indicatorColor="primary"
            textColor="primary"
          >
            {this.state.activetab}
          </Tabs>
        </AppBar>
        {/* {this.state.value === 0 && Secure("CREATE_USERS", <TabContainer><PowerBankTransactionReport /></TabContainer>)} */}
        {/* {this.state.value === 1 && <TabContainer><SecurityDepositReport /></TabContainer>} */}
        {/* {this.state.value === 1 && Secure("MAP_BOX_USER", <TabContainer><IncomeReportByStore /></TabContainer>)} */}
        {/* {this.state.value === 2 && Secure("MAP_BOX_USER", <TabContainer><BoxStatusReport /></TabContainer>)} */}
        {/* {this.state.value === 3 && Secure("VIEW_INVENTORY", <TabContainer><BoxInventoryReport /></TabContainer>)} */}
        {/* {this.state.value === 4 && Secure("VIEW_DEFAULT_CUSTOMER", <TabContainer><CustomerDefaultReport /></TabContainer>)} */}
        {/* {this.state.europeflag ? (this.state.value === 5 && Secure("VIEW_INVOICE", <TabContainer><InvoiceReport /></TabContainer>)) : (this.state.value === 5 && Secure("VIEW_REVENUE", <TabContainer><RevenueReport /></TabContainer>))} */}
        {/* {this.state.value === 5 && Secure("MAP_BOX_USER", <TabContainer><InvoiceReport /></TabContainer>)} */}
        {/* {!this.state.europeflag ? (this.state.value === 6 && <TabContainer><MerchantRevenueReport /></TabContainer>) : (this.state.value === 6 && Secure("VIEW_RENTAL_HISTORY", <TabContainer><RentalHistory /></TabContainer>))} */}
        {/* {this.state.value === 7 && Secure("MAP_BOX_USER", <TabContainer><StoreStatusReport /></TabContainer>)} */}
        {this.state.value === 0 && Secure("CREATE_USERS", <TabContainer><RentalHistoryReport /></TabContainer>)}
        {/* {this.state.value === 9 && Secure("READ_RENTALS", <TabContainer><RentalHistory/></TabContainer>)}
        {this.state.value === 10 && Secure("CREATE_USERS", <TabContainer><FailureReport /></TabContainer>)} */}

        {/* {this.state.value === 4 && <TabContainer><SalesLeadReport /></TabContainer>} */}
      </div>
    );
  }
}

ReportTabs.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return ({
    tab_permission: state.tab_permission
  })
}

export default connect(
  mapStateToProps, null
)(withStyles(styles)(ReportTabs))